import { css } from 'jimu-core';
export const formGroupStyles = (props) => {
    var _a;
    const isRow = props.row;
    const isCheck = props.check;
    const isInline = props.inline;
    const theme = props.theme;
    const formVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.form;
    return formVars && css `
    ${!isRow
        ? isCheck
            ? ''
            : `
      margin-bottom: ${formVars.group.marginBottom};
    `
        : `
      display: flex;
      flex-wrap: wrap;
      margin-right: -5px;
      margin-left: -5px;

      > .col,
      > [class*="col-"] {
        padding-right: 5px;
        padding-left: 5px;
      }
    `}

    ${isInline && `
      display: inline-flex;
      align-items: center;
      padding-left: 0;
      margin-right: ${formVars.check.inline.marginX};

      .form-check-input {
        position: static;
        margin-top: 0;
        margin-right: ${formVars.check.inline.inputMarginX};
        margin-left: 0;
      }
    `}
  `;
};
